import { render, staticRenderFns } from "./pointsTableForm.vue?vue&type=template&id=1c6a79be&scoped=true&"
import script from "./pointsTableForm.vue?vue&type=script&lang=js&"
export * from "./pointsTableForm.vue?vue&type=script&lang=js&"
import style0 from "./pointsTableForm.vue?vue&type=style&index=0&id=1c6a79be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a79be",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QCheckbox,QBtn,QSeparator,QScrollArea});
